<script setup>
import useBookingSession from "@/components/frontend/composable/useBookingSession.ts";
const { removeBooking } = useBookingSession();

const props = defineProps({
  booking: {
    type: Object,
    required: true
  },
  urlBooking: {
    type: String,
    required: true
  },
})

const emit = defineEmits(['canceling', 'canceled']);

const onClickCancelBooking = async () => {
  emit('canceling')
  try {
    await axios.delete(`${props.urlBooking}/${props.booking.uuid}`)
    emit('canceled')
    removeBooking();
  } catch (error) {
    console.log(error)
  }
}

</script>
<template>
  <button class="btn btn-outline-danger" type="button" @click="onClickCancelBooking">
    {{ $t('Cancel booking') }}
  </button>
</template>
